import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import gql from "graphql-tag";

@Injectable()
export class UsersService {
  constructor(private apollo: Apollo) {}

  list(obj?) {
    let variables = {};
    /* console.log("after", obj.paginationData.after.endCursor); */

    if (obj) {
      variables = {
        first: obj.paginationData.pageSize,
        after:
          obj.paginationData.next === undefined
            ? null
            : obj.paginationData.next.endCursor, // after should be a cursor, not a calculated value
        searchParam: obj.searchParam || null,
      };
    }

    return this.apollo.watchQuery({
      query: gql`
        query GetUsers($first: Int, $after: String, $searchParam: String) {
          users(first: $first, after: $after, searchParam: $searchParam) {
            pageInfo {
              hasNextPage
              endCursor
            }
            edges {
              cursor
              node {
                id
                name
                email
              }
            }
            totalCount
          }
        }
      `,
      variables: variables,

      errorPolicy: "all", // Capture and report any GraphQL errors
      fetchPolicy: "network-only",
    }).valueChanges;
  }

  read(id: string) {
    return this.apollo.watchQuery({
      query: gql`
          {
            user (id: "${id}") {
              id
              name
              email
              role
              allowPremium
              allowPrivate
            }
          }
        `,
    }).valueChanges;
  }

  update(obj) {
    return this.apollo.mutate({
      mutation: gql`
        mutation updateUser(
          $id: ID!
          $name: String!
          $allowPremium: Boolean!
          $allowPrivate: Boolean!
        ) {
          updateUser(
            user: {
              id: $id
              name: $name
              allowPremium: $allowPremium
              allowPrivate: $allowPrivate
            }
          ) {
            success
          }
        }
      `,
      variables: {
        id: obj.id,
        name: obj.name,
        allowPremium: obj.allowPremium,
        allowPrivate: obj.allowPrivate,
      },
    });
  }

  updateUserRole(obj) {
    return this.apollo.mutate({
      mutation: gql`
        mutation updateUserRole($userId: ID!, $roleId: Int!) {
          updateUserRole(user: { userId: $userId, roleId: $roleId }) {
            success
          }
        }
      `,
      variables: {
        userId: obj.userId,
        roleId: obj.roleId,
      },
    });
  }

  createUser(user: any) {
    return this.apollo.mutate({
      mutation: gql`
        mutation createUser(
          $name: String!
          $email: String!
          $password: String!
          $organizationId: String!
          $phoneNumber: String!
        ) {
          createUser(
            user: {
              name: $name
              email: $email
              password: $password
              organizationId: $organizationId
              phoneNumber: $phoneNumber
            }
          ) {
            id
          }
        }
      `,
      variables: {
        name: user.name,
        email: user.email,
        phoneNumber: user.phoneNumber,
        organizationId: user.organization.id,
        password: user.password,
      },
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/users.service.ts